/* eslint-disable import/prefer-default-export */
export const documentProcessorQueryKeys = {
  extractedPackingListTable: (filters: any) => ["extracted-packing-list", "list", filters],
  extractedPackingListDetail: (id: number) => ["extracted-packing-list", "detail", id],
};
